var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 3.96875C3.9375 3.70987 3.72763 3.5 3.46875 3.5C3.20987 3.5 3 3.70987 3 3.96875V13.0312C3 13.2901 3.20987 13.5 3.46875 13.5C3.72763 13.5 3.9375 13.2901 3.9375 13.0312V10.2866L4.97339 10.0685C5.87786 9.87809 6.8203 10.0044 7.64276 10.4261C8.79516 11.0171 10.1328 11.1347 11.3706 10.7538L12.6691 10.3543C12.8658 10.2938 13 10.112 13 9.90625V4.59375C13 4.45249 12.9363 4.31875 12.8266 4.22975C12.7169 4.14074 12.5729 4.10595 12.4347 4.13505L10.9473 4.44818C10.0719 4.63247 9.16159 4.55352 8.33099 4.22128L8.01719 4.09577C7.01474 3.69479 5.91604 3.59951 4.85953 3.82193L3.9375 4.01604V3.96875Z",
    fill: "#7A6007"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.44adf4a4edfc81902ff7da87c5da272d.svg";
export { ForwardRef as ReactComponent };